import {Action, createReducer, on} from '@ngrx/store';
import {initialShoppingCartState, ShoppingCartState} from '@store/state/shopping-cart';
import {
    loadShoppingCartSuccess,
    refreshShoppingCartSuccess,
    setShoppingCartArticlesSuccess,
    setShoppingCartDynamicArticlesSuccess,
    setShoppingCartVouchersSuccess,
    updateShoppingCartSuccess,
    deleteShoppingCartSuccess,
    increaseRequestsCounter, increaseRequestsDone
} from '@store/actions/shopping-cart.action';

export const initialState: ShoppingCartState | {
    pendingRequests: number
} | undefined | {} = initialShoppingCartState();
const getRequestsCounterFromState = (stateCurrent: ShoppingCartState | {} | undefined): number => {
    let value: number = 0;
    if (stateCurrent && 'requestsCounter' in stateCurrent) {
        value = stateCurrent.requestsCounter;
    }
    return value;
};
const getRequestsDoneFromState = (stateCurrent: ShoppingCartState | {} | undefined): number => {
    let value: number = 0;
    if (stateCurrent && 'requestsDone' in stateCurrent) {
        value = stateCurrent.requestsDone;
    }
    return value;
};

const ShoppingCartReducer = createReducer(
    initialState,


    on(loadShoppingCartSuccess, (state: ShoppingCartState | {} | undefined, {shoppingCart}): ShoppingCartState => {
            return {
                ...shoppingCart,
                requestsCounter: getRequestsCounterFromState(state),
                requestsDone: getRequestsDoneFromState(state)
            };
        }
    ),
    on(refreshShoppingCartSuccess, (state: ShoppingCartState | {} | undefined, {shoppingCart}): ShoppingCartState => {
            return {
                ...shoppingCart,
                requestsCounter: getRequestsCounterFromState(state),
                requestsDone: getRequestsDoneFromState(state)
            };
        }
    ),

    on(increaseRequestsCounter, (state: ShoppingCartState | {} | undefined): ShoppingCartState | {
            requestsCounter: number,
            requestsDone: number,
        } => {
            return {
                ...state,
                requestsCounter: getRequestsCounterFromState(state) + 1,
                requestsDone: getRequestsDoneFromState(state)
            };
        }
    ),
    on(increaseRequestsDone, (state: ShoppingCartState | {} | undefined): ShoppingCartState | {
            requestsCounter: number,
            requestsDone: number,
        } => {
            return {
                ...state,
                requestsCounter: getRequestsCounterFromState(state),
                requestsDone: getRequestsDoneFromState(state) + 1
            };
        }
    ),

    on(setShoppingCartArticlesSuccess, (state: ShoppingCartState | {} | undefined, {shoppingCart}): ShoppingCartState => {
            return {
                ...shoppingCart,
                requestsCounter: getRequestsCounterFromState(state),
                requestsDone: getRequestsDoneFromState(state)
            };
        }
    ),

    on(setShoppingCartDynamicArticlesSuccess, (state: ShoppingCartState | {} | undefined, {shoppingCart}): ShoppingCartState => {
            return {
                ...shoppingCart,
                requestsCounter: getRequestsCounterFromState(state),
                requestsDone: getRequestsDoneFromState(state)
            };
        }
    ),


    on(setShoppingCartVouchersSuccess, (state: ShoppingCartState | {} | undefined, {shoppingCart}): ShoppingCartState => {
            return {
                ...shoppingCart,
                requestsCounter: getRequestsCounterFromState(state),
                requestsDone: getRequestsDoneFromState(state)
            };
        }
    ),
    on(updateShoppingCartSuccess, (state: ShoppingCartState | {} | undefined, {shoppingCart}): ShoppingCartState => {
            return {
                ...shoppingCart,
                requestsCounter: getRequestsCounterFromState(state),
                requestsDone: getRequestsDoneFromState(state)

            };
        }
    ),
    on(deleteShoppingCartSuccess, (state: ShoppingCartState | {} | undefined): ShoppingCartState | {
            requestsCounter: number,
            requestsDone: number
        } => {
            return {
                requestsCounter: getRequestsCounterFromState(state),
                requestsDone: getRequestsDoneFromState(state)
            }
        }
    ),
);

export function reducer(state: ShoppingCartState | {
    requestsCounter: number,
    requestsDone: number
} | undefined | {}, action: Action) {
    return ShoppingCartReducer(state, action);
}
